import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Panel, PanelHeader, PanelBody } from '../../../components/admin/panel/panel';

import { usersActions } from '../../../store/users';

class Create extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            userName: '',
            password: '',
            confirmPassword: '',
            name: '',
            email: '',
            role: 'Admin',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { userName, password, role, confirmPassword, name, email } = this.state;
        if (userName && password && role && confirmPassword && name && email) {
            this.props.postUser(this.state);
            this.props.history.push('/admin/users');
        };
        this.setState({ submitted: true });
    }

    render() {

        const { userName, password, role, confirmPassword, name, email, submitted } = this.state;

        return (
            <div>
                <h1 className="page-header">관리자 계정</h1>
                <div className="row">
                    <div className="col-xl-6">
                        <Panel>
                            <PanelHeader>등록</PanelHeader>
                            <PanelBody>
                                <form onSubmit={this.handleSubmit} method="post">
                                    <div className="form-group">
                                        <label className="control-label">이름</label>
                                        <input onChange={this.handleChange} name="name" className="form-control" />
                                        { submitted && !name && <div className="help-block text-danger">필수 입력 항목입니다.</div> }
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label">이메일</label>
                                        <input onChange={this.handleChange} name="email" className="form-control" type="email" />
                                        { submitted && !email && <div className="help-block text-danger">필수 입력 항목입니다.</div> }
                                    </div>
                                    <div className="form-group">
                                        <label>역활</label>
                                        <select onChange={this.handleChange} name="role" className="form-control">
                                            <option value="Admin">Admin</option>
                                            <option value="Super">Super</option>
                                            <option value="User">User</option>
                                        </select>
                                        { submitted && !role && <div className="help-block text-danger">필수 입력 항목입니다.</div> }
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label">아이디</label>
                                        <input onChange={this.handleChange} name="userName"  className="form-control" />
                                        {submitted && !userName && <div className="help-block text-danger">필수 입력 항목입니다.</div> }
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label" type="password">패스워드</label>
                                        <input onChange={this.handleChange} name="password" className="form-control" type="password" />
                                        <small className="text-muted">Note: 6자 이상이 필요합니다.</small>
                                        {submitted && !password && <div className="help-block text-danger">필수 입력 항목입니다.</div> }
                                    </div>
                                    <div className="form-group">
                                        <label>패스워드 확인</label>
                                        <input onChange={this.handleChange} name="confirmPassword" className="form-control" type="password" />
                                        {submitted && !confirmPassword && <div className="help-block text-danger">필수 입력 항목입니다.</div> }
                                    </div>

                                    <hr className="m-b-10" /> 

                                    <div className="form-group text-right p-t-15">
                                        <button className="btn btn-success rounded-0 m-r-5">목록</button>
                                        <button type="submit" className="btn btn-inverse rounded-0">등록</button>
                                    </div>

                                </form>

                            </PanelBody> 
                        </Panel>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({ users: state.users }),
    dispatch => bindActionCreators({ ...usersActions }, dispatch)
)(withRouter(Create));


// WEBPACK FOOTER //
// ./src/pages/admin/users/create.js